import { useShop } from "@shopify/hydrogen-react";
import { useEffect, useRef } from "react";
import { useConsent } from "../consent/ConsentProvider";
import { sendViewAnalytics } from "./shopifyAnalytics";
import type { ViewAnalyticsEvent } from "./shopifyAnalytics";

/**
 * Sends a Shopify product, collection or search view once per `key`
 * (product ID, collection ID, search term), only with analytics consent.
 */
export function useViewAnalytics(
  event: ViewAnalyticsEvent | null,
  key: string | null,
) {
  const consent = useConsent();
  const { storeDomain, languageIsoCode } = useShop();
  const lastKey = useRef<string | null>(null);

  useEffect(() => {
    if (!event || !key || !consent.analyticsAllowed) return;
    if (lastKey.current === key) return;
    lastKey.current = key;

    void sendViewAnalytics({
      consent,
      storeDomain,
      language: languageIsoCode,
      event,
    });
    // The event object is rebuilt each render; the key decides when to send.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [key, consent, storeDomain, languageIsoCode]);
}
